import { connect } from 'react-redux';
import { updateField, updateCustomField } from '../actions/FormActions';
import { getFieldProps } from '../selectors/hybrid';
import Dropdown from '../components/Dropdown';

const mapStateToProps = (state, ownProps) => {
  const configuratorState = state.ConfiguratorStore;
  return getFieldProps(configuratorState, ownProps.field.name);
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const name = ownProps.field.name;
  return {
    changeHandler: (event) => {
      const value = event.target.value;
      dispatch(updateField(name, value));
    },
    customInputHandler: (event) => {
      const value = event.target.value.substring(0, 50);
      dispatch(updateCustomField(name, value));
    }
  }
};

const DropdownContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Dropdown);

export default DropdownContainer;
